<template>
  <div>
    <Head :title="Optout" />
    <div class="grid h-screen place-items-center text-center">
      <div class="">
        <h1 class="mb-8 font-bold text-3xl w-full content-center">
          Unsubscribe {{ contact.first_name }} {{ contact.last_name }}
        </h1>

        <flash-messages />
        <div class="grid place-items-center text-center bg-white rounded-md shadow overflow-hidden content-center p-20">
          <div class="mt-5">
            Click Unsubscribe below to Opt Out of future emails from Riverbank. Please note, once opt out you will no longer be able to recieve important updates regarding your mortgage.
          </div>
          <form @submit.prevent="update">
            <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 mx-20">
              <div class="text-center items-center">
                <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Unsubscribe Now</loading-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import LoadingButton from '@/Shared/LoadingButton'
import FlashMessages from '@/Shared/FlashMessages'
import { router } from '@inertiajs/vue3'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    Head,
    LoadingButton,
    FlashMessages,
  },
  props: {
    contact: Object,
  },
  data() {
    return {
      form: router.form({
        email: this.contact.email,
      }),
    }
  },
  methods: {
    update() {
      console.log('Unsubscribed User')
      this.form.put('/contacts/'+this.contact.id+'/optoutsend')
    },
  },
}
</script>
